import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import './MultiSelectDropdown.css';

const MultiSelectDropdown = ({ options, selectedValues, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggleOption = (optionValue) => {
    let newSelected;
    
    if (optionValue === 'All Universities') {
      // If clicking "All Universities", it toggles. If selecting it, deselect others.
      if (selectedValues.includes('All Universities')) {
        newSelected = [];
      } else {
        newSelected = ['All Universities'];
      }
    } else {
      // If clicking a specific university
      const currentSelected = selectedValues.filter(val => val !== 'All Universities');
      
      if (currentSelected.includes(optionValue)) {
        newSelected = currentSelected.filter(val => val !== optionValue);
      } else {
        newSelected = [...currentSelected, optionValue];
      }
      
      // If no specific universities are left, default back to 'All Universities'
      if (newSelected.length === 0) {
        newSelected = ['All Universities'];
      }
    }
    
    onChange(newSelected);
  };

  const getDisplayText = () => {
    if (selectedValues.length === 0) {
      return 'No universities selected';
    }
    if (selectedValues.includes('All Universities')) {
      return 'All Universities';
    }
    if (selectedValues.length === 1) {
      // Try to find the full name in options if possible
      return selectedValues[0];
    }
    return `${selectedValues.length} Universities Selected`;
  };

  return (
    <div className="multi-select-container" ref={containerRef}>
      <div 
        className="multi-select-header" 
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="multi-select-header-text">
          {getDisplayText()}
        </span>
        {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </div>
      
      {isOpen && (
        <div className="multi-select-dropdown">
          <label className="multi-select-option">
            <input 
              type="checkbox" 
              checked={selectedValues.includes('All Universities')}
              onChange={() => handleToggleOption('All Universities')}
            />
            <span>All Universities</span>
          </label>

          {options.map((option, idx) => (
            <label key={idx} className="multi-select-option">
              <input 
                type="checkbox" 
                checked={selectedValues.includes(option)}
                onChange={() => handleToggleOption(option)}
              />
              <span>{option}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
